var swiper = new Swiper(".social-swiper", {
    effect: "cards",
    grabCursor: true,
    centeredSlides: false,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

document.addEventListener("DOMContentLoaded", function() {
  var menuTrigger = document.getElementById("HeaderProductMenu");
  var customMenu = document.querySelector(".custom-menu");

  if (menuTrigger && customMenu) {
    menuTrigger.addEventListener("mouseenter", function() {
      customMenu.classList.add("active");
    });

    menuTrigger.addEventListener("mouseleave", function() {
      customMenu.classList.remove("active");
    });
  }
});
